import { Injectable } from '@angular/core';
import { RelayRepository } from '../../relay.repository';
import { LogoViewModel } from './logo.view.model';

@Injectable()
export class LogoPresenter {
  constructor(private relayRepository: RelayRepository) {}

  load(callback) {
    let vm: LogoViewModel;
    this.relayRepository.getCustomLogo((dm: { logoUrl: string; helpLabel: string }) => {
      vm = {
        customLogo: dm.logoUrl,
        showClose: false,
        helpLabel: dm.helpLabel,
        qaCustomerLogo: 'customerLogo',
        qaRequestHelp: 'requestHelp'
      };
      callback(vm);
    });
  }
}
